import React, { useContext, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { Container, Table, Button, Row, Col } from 'react-bootstrap'
import { getNames, deleteName } from '../actions/nameActions'
import Loader from '../components/Loader'
import Message from '../components/Message'
import PaginateName from '../components/PaginateName'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { ThemeContext } from '../components/ThemeContext.js'
import {
  EMPLOYEE_PERMISSIONS,
  hasEmployeePermission
} from '../constants/employeePermissions.js'

const ListManufacturers = ({ match }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { theme } = useContext(ThemeContext)

  const { pageNumbername } = useParams() || 1
  const { keyword } = useParams()

  const nameList = useSelector((state) => state.nameList)
  const { loading, error, manufacturer, count, pagesname, pagename } = nameList

  const nameDelete = useSelector((state) => state.nameDelete)
  const { success: successDelete } = nameDelete

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const isAuthenticated = Boolean(ownerInfo || userInfo)
  const canManageCatalog = hasEmployeePermission(
    userInfo,
    ownerInfo,
    EMPLOYEE_PERMISSIONS.CATALOG_MANAGE
  )

  const delName = (id) => {
    if (window.confirm('Are you sure?')) {
      dispatch(deleteName(id))
      dispatch({ type: 'NAME_DELETE_RESET' })
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getNames(pageNumbername, keyword))
    } else {
      dispatch({ type: 'NAME_LIST_RESET' })
      navigate('/login')
    }
  }, [
    dispatch,
    navigate,
    keyword,
    pageNumbername,
    isAuthenticated,
    userInfo,
    successDelete
  ])

  return (
    <Container style={{ color: theme.text }}>
      <Row>
        <Col>
          {' '}
          <PaginateName pagesname={pagesname} pagename={pagename} />
        </Col>
        {canManageCatalog && (
          <>
            <Col className='text-right'>
              <LinkContainer to='/settings'>
                <Button variant='primary' size='sm' className='my-2'>
                  Add a manufacturer
                </Button>
              </LinkContainer>
            </Col>
          </>
        )}
      </Row>

      {count === 0 && <Message variant='info'>None Found</Message>}
      {loading ?
        <Loader />
      : error ?
        <Message variant='danger'>{error}</Message>
      : <Table striped bordered hover responsive className='table-sm'>
          <thead className='my-2'>
            <tr>
              <th>
                <h3>Manufacturer</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            {manufacturer.map((name) => (
              <tr key={name._id}>
                <td>{name.manufacturer}</td>
                {canManageCatalog && (
                  <>
                    <td>
                      <Button
                        variant='danger'
                        size='sm'
                        onClick={() => delName(name._id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      }
    </Container>
  )
}

export default ListManufacturers
